import { NAME } from './constants';
import { router } from './router';

export const UzaverkaUcetni = {
	name: NAME,
	router,
};
